import { render } from "./sales-filter.vue?vue&type=template&id=c3ce7fa0"
import script from "./sales-filter.vue?vue&type=script&lang=js"
export * from "./sales-filter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__